import React from 'react';
import PropTypes from 'prop-types';
import Icon, { GLYPHS } from '../../../common/icon';
import UploadPhoto from '../../../common/uploadPhotoForm/uploadPhoto';
import { t } from '../../../../modules/infra/i18n';

const renderImage = (imageUrl) => {
  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        className="c-image-asset-upload__img"
        alt={t('admin:upload_image_asset.upload_alt_text')}
      />
    );
  }

  return (
    <Icon
      className="c-image-asset-upload__icon u-p-"
      glyph={GLYPHS.upload} size="medium"
    />
  );
};

const UploadImageAsset = ({ name, label, wrapperClass }) => (
  <div className={wrapperClass}>
    <div className="c-label-new">{label || t('admin:upload_image_asset.default_label')}</div>
    <div className="c-image-asset">
      <UploadPhoto name={name}>
        {renderImage}
      </UploadPhoto>
    </div>
  </div>
);
UploadImageAsset.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  wrapperClass: PropTypes.string,
};
UploadImageAsset.defaultProps = {
  label: null,
  wrapperClass: 'layout__item u-1/2-medium-and-up',
};

export default UploadImageAsset;
